import React from 'react';
import ApprovalFinalAuthContainer from '../../containers/approvalmng/ApprovalFinalAuthContainer';

const ApprovalFinalAuthPage = () => {
  return <ApprovalFinalAuthContainer />;
};

export default ApprovalFinalAuthPage;
